// Utils
import * as yup from 'yup';

export const formSchema = yup.object().shape({
  email: yup
    .string()
    .email('Invalid email')
    .required('Email is required')
    .default(''),
});

export type FormSchema = yup.InferType<typeof formSchema>;

export const initialValues: FormSchema = formSchema.cast({
  email: '',
});
